import Stack from "@mui/material/Stack";
import { ComponentProps } from "../types";
import DashboardComponent from "./DashboardComponent";
import { CSSProperties, useContext, useMemo } from "react";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import DashboardPageContext from "../DashboardPageContext";

function Component({ component }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const direction = useMemo(() => (component.properties["direction"] || "column") as "row" | "row-reverse" | "column" | "column-reverse", [component]);
	const exeMode = useContext(ExecutionTypeContext);
	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties["flex"]) style.flex = component.properties["flex"];
		return style;
	}, [component, exeMode]);
	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context, exeMode]);
	return (
		<Stack style={style} key={component.id} direction={direction} spacing={parseInt(component.properties["spacing"] || "0")} alignItems={component.properties["alignItems"] || "flex-start"} justifyContent={component.properties["justifyContent"] || "flex-start"} {...args}>
			{component.childern && component.childern.map((c, i) => <DashboardComponent key={i} component={c} />)}
		</Stack>
	);
}

export default Component;
